import { IMenu } from '@/models/IMenu'

export const Menus: IMenu[] = [
  { title: 'menu.home', to: { name: 'home' } },
  { title: 'menu.products', to: { name: 'products' } },
  { title: 'menu.vision', to: { name: 'vision' } },
  { title: 'menu.about', to: { name: 'team'} },
  { title: 'menu.privacy', to: { name: 'content', params: { key: 'privacy' } } },
  { title: 'menu.terms', to: { name: 'content', params: { key: 'terms' } } },
  { title: 'menu.imprint', to: { name: 'content', params: { key: 'imprint' } } },
  { title: 'menu.investors', to: { name: 'investors' } },
  { title: 'menu.contact', to: { name: 'contact' } },
]